// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";  // Importing Firebase Storage

const firebaseConfig = {
  apiKey: "AIzaSyCZ189GUfiYhLPJfAZTwdfrdJupI-CrJOw",
  authDomain: "ryan-tutors.firebaseapp.com",
  projectId: "ryan-tutors",
  storageBucket: "ryan-tutors.firebasestorage.app",  // Firebase Storage Bucket
  messagingSenderId: "1011578644133",
  appId: "1:1011578644133:web:405c1d3796bb3cdbdc0f4c",
  measurementId: "G-CT97NN7VC4"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); 
export const storage = getStorage(app);  // Initialize Firebase Storage
export const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);
